import { render, staticRenderFns } from "./ListaLicencas.vue?vue&type=template&id=0071b9a7&scoped=true&"
import script from "./ListaLicencas.vue?vue&type=script&lang=js&"
export * from "./ListaLicencas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0071b9a7",
  null
  
)

export default component.exports